import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const DesktopApps = () => {
  const services = [
    'Windows Desktop Applications',
    'macOS Native Applications',
    'Linux Desktop Software',
    'Cross-Platform Solutions (Electron)',
    'Command-Line Interface (CLI) Tools',
    'System Utilities & Tools'
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Desktop Application Development</h1>
          <p>
            Command-based and GUI solutions for Windows, Linux, and macOS 
            with native performance and user experience.
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Overview</h2>
            <p>
              Desktop applications provide powerful, offline-capable solutions for businesses that need 
              high-performance software with direct system access. We develop native and cross-platform 
              desktop applications using modern frameworks and technologies.
            </p>
            <p>
              Whether you need a Windows-only application, a cross-platform solution, or command-line 
              tools for automation, we deliver desktop software that integrates seamlessly with your 
              operating system and existing workflows.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header">
            <h2>Desktop Development Services</h2>
            <p>Native and cross-platform desktop application capabilities</p>
          </div>
          <div className="expertise-grid">
            {services.map((service, index) => (
              <div key={index} className="expertise-item">
                {service}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-values">
        <div className="container">
          <div className="section-header">
            <h2>Why Desktop Applications?</h2>
            <p>Advantages of desktop software for your business</p>
          </div>
          
          <div className="values-grid">
            <div className="value-card">
              <h3>Native Performance</h3>
              <p>
                Direct access to system resources provides superior performance compared to web 
                applications, especially for resource-intensive tasks.
              </p>
            </div>
            <div className="value-card">
              <h3>Offline Capability</h3>
              <p>
                Work without internet connectivity. Desktop apps function fully offline, syncing 
                data when connection is restored.
              </p>
            </div>
            <div className="value-card">
              <h3>System Integration</h3>
              <p>
                Deep integration with operating system features like file systems, notifications, 
                hardware devices, and system services.
              </p>
            </div>
            <div className="value-card">
              <h3>Enhanced Security</h3>
              <p>
                Better control over data storage and security. Sensitive information stays on 
                local machines with encrypted storage options.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Technologies We Use</h2>
            <p>
              <strong>Native Development:</strong> We build platform-specific applications using 
              C#/.NET for Windows, Swift for macOS, and C++/Qt for Linux to achieve maximum 
              performance and native look-and-feel.
            </p>
            <p>
              <strong>Cross-Platform:</strong> For applications that need to run on multiple 
              operating systems, we use Electron, Qt, or .NET MAUI to write once and deploy 
              everywhere while maintaining native performance.
            </p>
            <p>
              <strong>CLI Tools:</strong> We develop command-line applications and automation 
              scripts using Python, Go, Rust, or Node.js for system administrators and power users.
            </p>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Build Your Desktop Application</h2>
            <p>Discuss your desktop software requirements and technical specifications.</p>
            <Link to="/contact">
              <Button 
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#2271b1',
                  color: '#ffffff',
                  fontWeight: '600',
                  padding: '14px 32px',
                  fontSize: '15px',
                  textTransform: 'none',
                  borderRadius: '3px',
                  boxShadow: '0 1px 0 #135e96',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#135e96',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }
                }}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DesktopApps;
